
import React, { useState, useEffect } from "react";
import "./dsr.scss";
import Sidebar from "../Sidebar";
import Header from "../../component/loaderComponent/Header/Header";
import { useDispatch } from "react-redux";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import NoDataFound from "../../component/noDataComponent/NoDataFound";
import { Image_Url } from "../../ImageUrl/ImageUrl";
import { useNavigate } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { notify } from '../../services/notification';
import { encode } from "base-64";
import { HiMenu, HiX } from "react-icons/hi";
import { constant } from "../../constants/constant";
import useMobileView from "../../constants/useMobileView";
import ConfirmationPopupDsr from "../../component/ConfirmationPopupDsr";
import { dowloaddsrlistAction, DsrIsActiveViewAction, DsrListAction } from "../../actions/dsrAction";


function Dsr() {
  const [isLoading, setLoading] = useState(false);
  const [criteria, setcriteria] = useState("");
  const { isSidebarOpen, toggleSidebar } = useMobileView();

  const [dsrNamesList, setDsrNamesList] = useState([]);
  const [paginationListcount, setpaginationListcount] = useState(0);
  const [count, setCount] = useState(1);

  const [page, setPage] = useState(1);
  const [searchvalue, setSearchValue] = useState("");
  const [currentStatusId, setCurrentStatusId] = useState("");
  const [currentStatusValue, setCurrentStatusValue] = useState(false);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [reason, setReason] = useState("");
  const [statusValue, setStatusValue] = useState("");
  const [currentDsrName, setCurrentDsrName] = useState("");

  const dispatch = useDispatch();

  async function handleCriteriaChange(event) {
    setcriteria(event.target.value)
  }

  async function handleSearchChange(event) {
    setSearchValue(event.target.value)
    if (event.target.value === "") {
      // Instead of reloading, reset filters and fetch data
      setcriteria("");
      setStatusValue("");
      GetDsrNameListData(1);
    }
  }

  const handleStatusChange = (event) => {
    const value = event.target.value;
    setStatusValue(value);
    if (value.length === 0) {
      // Instead of reloading, just fetch data without status filter
      GetDsrNameListData(1);
    }
  };

  async function GetDsrNameListData(pageNumber, query) {
    setLoading(true);
    var response = await dispatch(DsrListAction(pageNumber, constant.paginationCount, query));
    if (response?.status === 200) {
      setLoading(false);
      setDsrNamesList(response?.data?.results?.data);
      setpaginationListcount(response.data.count)
      setCount(Math.ceil(response.data.count / constant.paginationCount))
    }
  }

  const search = () => {
    let query = "";
    if (criteria && searchvalue) {
      query += `&${criteria}=${searchvalue}`;
    }
    if (statusValue) {
      query += `&is_active=${statusValue}`;
    }
    GetDsrNameListData(1, query);
  };


  const CreateUser = (evt) => {
    navigate('/createdsr')
  }

  const navigate = useNavigate();

  useEffect(() => {
    GetDsrNameListData(1)
  }, []);

  const UpdateDsr = (id) => {
    window.scroll(0, 0);
    const encodeid = encode(id);
    navigate(`/editdsr/${encodeid}`);
  }

  const handlePageChange = (event, value) => {
    setPage(value);
    let query = "";
    if (criteria && searchvalue) {
      query += `&${criteria}=${searchvalue}`;
    }
    if (statusValue) {
      query += `&is_active=${statusValue}`;
    }
    GetDsrNameListData(value, query);
  };


  const handleOpenStatusConfirmationModal = (id, checked, name) => {
    setCurrentStatusId(id);
    setCurrentStatusValue(checked);
    setCurrentDsrName(name);
    setOpenStatusModal(true);
  };

  const handleCloseStatusConfirmationModal = () => {
    setCurrentStatusId("");
    setCurrentStatusValue(false);
    setOpenStatusModal(false);
    setReason("");
  };

  const handleStatusConfirmation = async () => {
    await handleOnActiveClick(currentStatusId, currentStatusValue ? "true" : "false", reason);

    // Update the local state to reflect the change
    const newData = dsrNamesList?.map(item => {
      if (item?.id === currentStatusId) {
        return { ...item, is_active: currentStatusValue };
      }
      return item;
    });
    setDsrNamesList(newData);

    handleCloseStatusConfirmationModal();
    await GetDsrNameListData(page);
  };

  const handleCheckboxChange = (id, checked, name) => {
    handleOpenStatusConfirmationModal(id, checked, name);
  };

  const handleOnActiveClick = async (id, data, reasonText) => {
    const apiReq = {
      reason: reasonText,
    }
    setLoading(true);
    let response = await dispatch(DsrIsActiveViewAction(apiReq, id));
    if (response?.status === 200) {
      notify.success(response.data.message);
      setLoading(false);
      window.scroll(0, 0);
    } else {
      setLoading(false);
      notify.error(response?.data?.message);
    }
  }
  async function downloadDsrList() {
    try {
      // let query = `&${criteria}=${searchvalue}`
      let query = "";
      if (criteria && searchvalue) {
        query = `&${criteria}=${searchvalue}`;
      }
      if (statusValue) {
        query = `&is_active=${statusValue}`;
      }
      const fileBlob = await dispatch(dowloaddsrlistAction(1, query));

      if (fileBlob) {
        const blobUrl = URL.createObjectURL(fileBlob);
        const newWindow = window.open(blobUrl, '_blank');
        if (newWindow) {
          newWindow.focus();
        } else {
          notify.error('Popup blocked. Please allow popups for this website');
        }
      }
    } catch (error) {
      notify.error('Error downloading file:', error);
    }
  }

  const startItem = dsrNamesList?.length === 0 ? 0 : (page - 1) * constant.paginationCount + 1;
  const endItem = Math.min(page * constant.paginationCount, paginationListcount);

  return (
    <div className="dsr-container">
      <div className="dsr-right-sidebar">
        <Header title="DSR List" />
        {isLoading ? (
          <Loader />
        ) : (
          <div className="dsr-first-collumn">
            <div className="Final">
              <div className="dsrs">
                <div className="dsr">
                  <select className="dsr-fields-dropdowns" value={statusValue} onChange={handleStatusChange}>
                    <option value="">Status</option>
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </select>
                  <select className="dsr-fields-dropdowns" value={criteria} onChange={handleCriteriaChange}>
                    <option value="">Select Criteria</option>
                    <option value="mobile_number">Mobile Number</option>
                    <option value="name">DSR Name</option>
                    <option value="dsr_id">DSR Id</option>
                  </select>
                  <input
                    type="search"
                    className="dsr-search-input"
                    placeholder="Enter a Value"
                    name="nameValue"
                    value={searchvalue}
                    disabled={!criteria}
                    onChange={handleSearchChange}
                  />
                  <button className="search-dsr" type="button" onClick={search}>Search</button>
                </div>
                <div className="dsr-button">
                  <button
                    type="button"
                    className="create-dsr"
                    onClick={CreateUser}
                  >
                    Create DSR +
                  </button>
                  <button className="download-excel-button" onClick={downloadDsrList}>
                    <img src={Image_Url.EXCEL_LOGO} className="download-excel-icon" />
                    Download Excel
                  </button>
                </div>
              </div>
            </div>
            {dsrNamesList?.length > 0 ?
              <div className="table-data">

                <table className="table">
                  <tr className="tablesth">
                    <th>DSR Id</th>
                    <th>Name</th>
                    <th>APS Name</th>
                    <th>APS Code</th>
                    <th>Employee Code</th>
                    <th>Phone Number</th>
                    <th>Pincode</th>
                    <th>Status</th>
                    <th>Created on</th>
                    <th>Deactivated on</th>
                    <th>Created by</th>
                    <th>Action</th>
                  </tr>
                  {dsrNamesList.map((data, index) => (
                    <tr className="tabletd">
                      <td>
                        <span className="dsr-id-link" onClick={() => UpdateDsr(data?.id)}>{data?.id}</span>
                      </td>
                      <td>{data?.name}</td>
                      <td className="long_text" title={data?.aps_name}>{data?.aps_name}</td>
                      <td>{data?.aps_code}</td>
                      <td>{data?.employee_code}</td>
                      <td>{data?.mobile_number}</td>
                      <td>{data?.pincode}</td>
                      <td>{data?.is_active === false ? "Deactivated" : "Activated"}</td>
                      <td>{data?.created_at
                        ? new Date(data?.created_at).toLocaleDateString()
                        : "N/A"}</td>
                      <td>{data?.deactivated_on ? new Date(data?.deactivated_on).toLocaleDateString() : "N/A"}</td>
                      <td>
                        {data?.created_by
                          ? `${data.created_by.id} - ${data.created_by.name}`
                          : "No creator info"}
                      </td>
                      <td className="tabletdV">
                        <div className="edit-icons">
                          <img
                            src={Image_Url.EDIT}
                            className="editicons"
                            onClick={() => UpdateDsr(data?.id)}
                          />
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={data.is_active}
                              disabled={!data.is_active}
                              onChange={(e) => handleCheckboxChange(data?.id, e.target.checked, data?.name)}
                            />
                            <span className="slider round"></span>
                          </label>

                        </div>
                      </td>
                    </tr>
                  ))}
                </table>


              </div>
              : <NoDataFound />}
            <div className="Pagination_section">
              <Stack spacing={2}>
                <Pagination
                  count={count}
                  className="pagination"
                  page={page}
                  size="medium"
                  defaultPage={1}
                  color="primary"
                  onChange={handlePageChange}
                />
              </Stack>
              <div className="count">
                <b>
                  <span>Displaying {startItem} to {endItem} out of {paginationListcount}</span>
                </b>
              </div>
            </div>
          </div>
        )}
      </div>

      <ConfirmationPopupDsr
        openDeleteModal={openStatusModal}
        handleOnDeleteClick={handleStatusConfirmation}
        handleCloseDeleteConfirmationModal={handleCloseStatusConfirmationModal}
        messageHeading={"WARNING!"}
        messageBody={`Are you sure you want to ${currentStatusValue ? "activate" : "deactivate"} ${currentDsrName}?`}
        isLoading={isLoading}
        loadingMessage={"Updating..."}
        reason={reason}
        setReason={setReason}
      />
    </div>
  );
}

export default Dsr;